import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=384a293b&"
import script from "./Delegates.vue?vue&type=script&lang=js&"
export * from "./Delegates.vue?vue&type=script&lang=js&"
import style0 from "./Delegates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports